// Obtendo o valor do atributo data-tempodelay como uma string
var tempoDelayString = document.querySelector("#banner-slide").dataset.tempodelay;

// Convertendo a string em um número (float)
var tempoDelay = parseFloat(tempoDelayString);

// Multiplicando por 1000 para converter para milissegundos
var tempoFinal = tempoDelay * 1000;

// Inicialização do Swiper com configurações otimizadas para fade
const swiper = new Swiper('#banner-slide', {
  // Usando effect fade conforme solicitado
  effect: "fade",
  
  // Configurações do fade
  fadeEffect: {
    crossFade: true
  },
  
  // Velocidade da transição em milissegundos
  speed: 800,
  
  // Autoplay configurado
  autoplay: {
    delay: tempoFinal,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  
  // Configuração da paginação
  pagination: {
    el: "#banner-bloco-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '" aria-label="Ir para slide ' + (index + 1) + '"></span>';
    }
  },
  
  // Loop infinito
  loop: true,
  
  // Permite interação
  allowTouchMove: true,
  grabCursor: true,
  
  // Previne bugs de renderização
  observer: true,
  observeParents: true,
  
  // Lazy loading desativado para evitar problemas com fade
  lazy: false,
  preloadImages: true,
  updateOnImagesReady: true,
  
  // Acessibilidade
  a11y: {
    prevSlideMessage: 'Slide anterior',
    nextSlideMessage: 'Próximo slide',
    firstSlideMessage: 'Este é o primeiro slide',
    lastSlideMessage: 'Este é o último slide',
    paginationBulletMessage: 'Ir para slide {{index}}'
  },
  
  // Callbacks para garantir transições suaves
  on: {
    init: function() {
      // Adiciona classe específica para identificar o container
      this.el.classList.add('swiper-container-fade');
    },
    slideChangeTransitionStart: function() {
      // Garante que apenas o slide ativo seja visível
      this.slides.forEach((slide, index) => {
        if (index !== this.activeIndex) {
          slide.style.opacity = '0';
          slide.style.pointerEvents = 'none';
        }
      });
    },
    slideChangeTransitionEnd: function() {
      // Restaura a visibilidade do slide ativo
      const activeSlide = this.slides[this.activeIndex];
      if (activeSlide) {
        activeSlide.style.opacity = '1';
        activeSlide.style.pointerEvents = 'auto';
      }
    }
  }
});

// Pausar autoplay quando a página não está visível
document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    swiper.autoplay.stop();
  } else {
    swiper.autoplay.start();
  }
});